import React, { FC, useContext, useEffect, useState } from 'react';
import CustomDialog from '../../../../common/components/CustomDialog';
import { Box, CircularProgress } from '@material-ui/core';
import { BusinessContext } from '../../BusinessProvider/BusinessProvider';
import BusinessDetailHeader from '../../Header/BusinessDetailHeader';
import { formatDate, getFullName } from '../../utils/utils';
import CustomSelect from '../../../../common/components/CustomSelect';
import ConfirmationButtons from '../../../ConfirmationButtons/ConfirmationButtons';
import { useGetMandataries } from '../../../../hooks/queries/useGetMandataries';
import { OptionType } from '../../../../common/components/CustomSelect/CustomSelect';

interface Props {
  onClose: () => void;
}

export const EditBusinessExpertModal: FC<Props> = (props) => {
  const { onClose } = props;
  const { businessState, setBusinessState } = useContext(BusinessContext);
  const { data, loading } = useGetMandataries();
  const [selectedExpert, setSelectedExpert] = useState<number | null>(null);

  const experts: OptionType[] =
    data?.mandataries.map((mandatary) => ({
      value: mandatary?.id,
      label: getFullName({
        firstName: mandatary?.firstName,
        lastName: mandatary?.lastName,
      }),
    })) || [];

  const _mandatary =
    data?.mandataries?.find((expert) => expert?.id === selectedExpert) ||
    businessState?.mandatary;

  useEffect(() => {
    if (businessState?.mandatary?.id)
      setSelectedExpert(businessState?.mandatary?.id);
  }, [businessState]);

  const handleChangeExpert = (
    event: React.ChangeEvent<{
      name?: string | undefined;
      value: unknown;
    }>,
  ) => {
    const value = event.target.value;
    setSelectedExpert(value as number);
  };

  return (
    <CustomDialog loading={false} maxWidth="sm" onClose={onClose} open={true}>
      <BusinessDetailHeader
        fullName={getFullName({
          firstName: businessState.firstName,
          lastName: businessState.lastName,
        })}
        apaName={getFullName({
          firstName: businessState.apa.firstName,
          lastName: businessState.apa.lastName,
        })}
        mandataryName={getFullName({
          firstName: businessState.mandatary?.firstName || '',
          lastName: businessState.mandatary?.lastName || '',
        })}
        createdAt={formatDate(businessState.createdAt)}
        apaEnseigneName={businessState.apa.enseigneName}
        status={businessState.step.label}
      />
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight={100}
        pt={2}
        pb={2}>
        {loading ? (
          <CircularProgress size={22} />
        ) : (
          <CustomSelect
            label="Sélectionner un nouveau expert"
            value={selectedExpert}
            options={experts}
            onChange={handleChangeExpert}
          />
        )}
      </Box>

      <ConfirmationButtons
        handleCancel={onClose}
        handleConfirm={() => {
          if (_mandatary)
            setBusinessState((prevState) => ({
              ...prevState,
              mandatary: {
                id: _mandatary?.id,
                lastName: _mandatary?.lastName,
                firstName: _mandatary?.firstName,
              },
            }));
          onClose();
        }}
      />
    </CustomDialog>
  );
};
